import React, { useRef } from "react";
import { Box, IconButton } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";

import Upload, { UploadRef } from "@app/components/atoms/Upload";

type UploadAudioProps = {
  url?: string;
  error?: boolean;
  errorMessage?: string;
  onRemoveFile: () => void;
  onUploadSuccess: (fileUrl: string) => void;
};

const UploadAudio = ({
  onRemoveFile,
  url,
  error,
  errorMessage,
  onUploadSuccess,
}: UploadAudioProps) => {
  const uploadRef = useRef<UploadRef>(null);

  const handleUploadSuccess = (fileUrl: string) => {
    onUploadSuccess(fileUrl);
  };

  const handleClearField = () => {
    onRemoveFile();
    uploadRef.current?.clearField();
  };

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      {url && (
        <Box sx={{ mb: 2 }}>
          <audio controls>
            <source src={url} />
            Your browser does not support the audio element.
          </audio>
        </Box>
      )}
      <Upload
        ref={uploadRef}
        destination="LESSON"
        accept={{ audio: true }}
        error={error}
        errorMessage={errorMessage}
        label="Escolha um arquivo de aúdio"
        onUploadSuccess={handleUploadSuccess}
      />
      {url && (
        <IconButton onClick={handleClearField}>
          <DeleteIcon />
        </IconButton>
      )}
    </Box>
  );
};

export default UploadAudio;
